import { createAction } from 'modules/redux-store';

export const destinationActions = {
  setCategory: (category: DestinationCategory) =>
    createAction('destination/SET_CATEGORY', { category }),
};
